// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1yAJr","row-wrapper":"_3iRNL","cancel-btn-div":"_1X2PS","cancel-btn":"_3xC7u"};